/**
 * 用户账户信息 — POST /cloud/user_account/getlist
 * 供 indiv 顶栏头像、个人中心基本信息等共用。
 */
import Vue from 'vue';
import request from '@/utils/request';

/** 用户账户全局状态（响应式，跨组件共享） */
export const userAccountState = Vue.observable({
  loading: false,
  loaded: false,
  /** getlist 返回的完整 data */
  profile: null,
});

let inflightRequest = null;

/** 将头像路径同步到 vuex，供顶栏/侧边栏展示 */
function syncSelfImageToStore(store, selfImage) {
  if (!store || !store.state || !store.state.usermsg || !selfImage) {
    return;
  }
  if (typeof store.state.usermsg === 'object') {
    store.state.usermsg.selfImage = selfImage;
  }
}

/** 请求用户账户信息（原始 HTTP，不写入 state） */
export function fetchUserAccount() {
  return request.post('/cloud/user_account/getlist').catch(() => null);
}

/**
 * 拉取用户账户并更新 userAccountState
 * @param {object} options
 * @param {boolean} options.force 是否强制重新请求
 * @param {object} options.store 可选，传入后同步 selfImage 到 vuex
 */
export function refreshUserAccount(options = {}) {
  const { force = false, store = null } = options;

  if (!force && userAccountState.loaded) {
    return Promise.resolve(userAccountState.profile);
  }

  if (inflightRequest) {
    return inflightRequest;
  }

  userAccountState.loading = true;

  inflightRequest = fetchUserAccount()
    .then((profile) => {
      userAccountState.profile = profile;
      userAccountState.loaded = true;
      if (profile && profile.selfImage) {
        syncSelfImageToStore(store, profile.selfImage);
      }
      return profile;
    })
    .catch(() => userAccountState.profile)
    .finally(() => {
      userAccountState.loading = false;
      inflightRequest = null;
    });

  return inflightRequest;
}

/** 退出登录时清空用户账户缓存 */
export function resetUserAccountState() {
  userAccountState.loading = false;
  userAccountState.loaded = false;
  userAccountState.profile = null;
  inflightRequest = null;
}



// WEBPACK FOOTER //
// ./src/view/user/userAccount/userAccountService.js